<template>
  <v-card flat>
    <v-card-title>
      <search-by :datasource="datasource" attr="code" />
      <search-by :datasource="datasource" attr="libelle" />
      <v-btn v-if="canCreate" @click="initCreation" color="primary">{{
        $t('button.new')
      }}</v-btn>
    </v-card-title>
    <v-card-text>
      <datasource-table :datasource="datasource">
        <template #item.actif="{item}">
          {{ getEnumStatus(item.actif) }}
        </template>
        <template #item.actions="{item}">
          <v-icon v-if="canUpdate" @click="initModification(item)"
            >mdi-pencil</v-icon
          >
          <v-icon v-else @click="initVisualisation(item)">mdi-eye</v-icon>
          <v-icon v-if="canDelete" @click="deactivateItem(item)"
            >mdi-delete</v-icon
          >
        </template>
      </datasource-table>
      <c-dialog persistent :dialog="modalDeactivate" max-width="50%">
        <c-deactivate-modal
          @deactivate="confirmDeactivate"
          @close="abortDeactivate"
        />
      </c-dialog>
      <c-dialog persistent :dialog="modalEdition" max-width="50%">
        <parametre-enum-dialog
          v-model="form"
          :title="getModalEditionTitle()"
          :modeModification="this.modeModification"
          :modeCreation="this.modeCreation"
          :codeUpdatable="this.canUpdateCode"
          :enumType="this.api.enumType"
          :extraFields="this.extraFields"
          @abort="abortEdition"
          @confirm="confirmEdition($event)"
        />
      </c-dialog>
    </v-card-text>
    <v-card-actions>
      <slot name="actions_gauche" />
      <v-spacer />
      <slot name="actions_centre" />
      <v-spacer />
      <slot name="actions_droite">
        <v-btn color="default" @click="quit" :title="$t('button.cancel')">{{
          this.$t('button.quit')
        }}</v-btn>
      </slot>
    </v-card-actions>
  </v-card>
</template>

<script>
import Datasource from '@/utils/datasource';
import toasted from '@/utils/toasted';

export default {
  provide() {
    return {
      $vroot: this.$v,
    };
  },
  props: {
    /** Titre de la page */
    title: {
      type: String,
      default: null,
    },
    /** L'API de communication avec le back */
    api: {},
    /** Les infos pour le retour vers le menu paramétrage */
    returnRoute: {},
    extraFields: {},
    restrictions: {},
  },
  data() {
    var datasource;

    return {
      datasource,
      /** Indique si on est en mode création */
      modeCreation: false,
      /** Indique si on est en mode modification */
      modeModification: false,
      /** Active la boîte de dialogue de désactivation */
      modalDeactivate: false,
      /** Active la boîte de dialogue d'édition */
      modalEdition: false,
      form: {
        id: null,
        enumType: 'default',
        code: '',
        libelle: '',
        libelleCourt: '',
        actif: true,
      },
      blankForm: {},
      blankStaticEnum: {
        fieldName: '',
        fieldType: '',
        value: {
          id: '',
          libelle: '',
        },
      },
      validate: false,
    };
  },
  beforeCreate() {},
  created() {
    // Ajout des champs complémentaires définis dans route.js
    var datasourceExtraFields = null;
    if (this._props.extraFields) {
      datasourceExtraFields = [];
      this._props.extraFields.forEach(extraField => {
        this.$set(this.form, extraField.name, null);
        if (extraField.type === 'staticEnum') {
          this.$set(
            this.form,
            extraField.name + 'Object',
            Object.assign({}, this.blankStaticEnum),
          );
        }
        if (extraField.viewInList) {
          datasourceExtraFields.push(extraField);
        }
      });
    }
    this.datasource = this.buildDatasource(datasourceExtraFields);
    Object.assign(this.blankForm, this.form);
  },
  beforeMount() {},
  mounted() {
    this.search();
  },
  computed: {
    canCreate() {
      return !(this.restrictions && this.restrictions.create === false);
    },
    canUpdate() {
      return !(this.restrictions && this.restrictions.update === false);
    },
    canDelete() {
      return !(this.restrictions && this.restrictions.delete === false);
    },
    canUpdateCode() {
      return this.restrictions && this.restrictions.codeUpdatable === true;
    },
  },
  methods: {
    buildDatasource(extraFields) {
      var datasourceFields = [
        {
          value: 'code',
          text: this.$t('administration.parametreenum.table.headers.code'),
          sortable: true,
        },
        {
          value: 'libelle',
          text: this.$t('administration.parametreenum.table.headers.libelle'),
          sortable: true,
        },
        {
          value: 'actif',
          text: this.$t('administration.parametreenum.table.headers.actif'),
          sortable: true,
        },
      ];
      if (extraFields != null) {
        extraFields.forEach(extraField => {
          datasourceFields.push({
            value:
              extraField.type === 'enum'
                ? extraField.name + '.libelle'
                : extraField.name,
            text: this.$t(
              'administration.parametreenum.table.headers.extra.' +
                extraField.name,
            ),
            sortable: true,
          });
        });
      }
      datasourceFields.push({
        value: 'actions',
        text: this.$t('administration.parametreenum.table.headers.actions'),
      });

      var datasource = new Datasource(this.api.url + '/' + this.api.enumType, {
        page: 1,
        rowsPerPage: 20,
        labelNamespace: 'administration.parametreenum',
        sortBy: 'libelle',
        descending: false,
        fields: datasourceFields,
      });
      return datasource;
    },
    getEnumStatus(value) {
      return this.$t(
        'administration.parametreenum.table.fields.actif.' + value,
      );
    },

    getApiReadUrl() {
      return this.api.readUrl
        ? this.api.readUrl
        : this.api.url + '/' + this.api.enumType;
    },
    getApiWriteUrl() {
      return this.api.writeUrl
        ? this.api.writeUrl
        : this.api.url + '/' + this.api.enumType;
    },
    quit() {
      this.$router.replace(this.returnRoute);
    },
    search() {
      // Recherche
      this.datasource.refresh();
    },
    /**
     * Entrée en mode création
     */
    initCreation() {
      this.modeCreation = true;
      this.modeModification = false;
      this.emptyForm();
      this.initFormDefaultValues();
      this.modalEdition = true;
    },
    /**
     * Entrée en mode modification
     */
    initModification(item) {
      this.modeCreation = false;
      this.modeModification = true;
      this.itemToForm(item);
      this.modalEdition = true;
    },
    /**
     * Entrée en mode visualisation
     */
    initVisualisation(item) {
      this.modeCreation = false;
      this.modeModification = false;
      this.itemToForm(item);
      this.modalEdition = true;
    },
    /**
     * Annulation de l'édition (création ou modification)
     */
    abortEdition() {
      this.modalEdition = false;
      this.modeCreation = false;
      this.modeModification = false;
      this.emptyForm();
      toasted.info('administration.parametreenum.results.cancel.success');
    },
    /**
     * Validation de l'édition (création ou modification)
     */
    confirmEdition(status) {
      if (this.modeCreation) {
        if (status) {
          this.updateFormSpecialFields();
          this.$api(this.getApiWriteUrl())
            .put(this.form)
            .then(
              () => {
                toasted.info(
                  'administration.parametreenum.results.create.success',
                );
                this.endEdition();
                this.search();
              },
              () => {
                toasted.error(
                  'administration.parametreenum.results.create.error',
                );
              },
            );
        } else {
          toasted.error('administration.parametreenum.results.create.invalid');
        }
      } else if (this.modeModification) {
        if (status) {
          this.updateFormSpecialFields();
          this.$api(this.getApiWriteUrl() + '/' + this.form.id)
            .post(this.form)
            .then(
              () => {
                toasted.info(
                  'administration.parametreenum.results.update.success',
                );
                this.endEdition();
                this.search();
              },
              () => {
                toasted.error(
                  'administration.parametreenum.results.update.error',
                );
              },
            );
        } else {
          toasted.error('administration.parametreenum.results.update.invalid');
        }
      } else {
        toasted.error('administration.parametreenum.results.noop.invalid');
        this.endEdition();
        this.search();
      }
    },
    /**
     * Fin de l'édition
     * On vide le form, on ferme toutes les fenêtres modales
     */
    endEdition() {
      this.modalEdition = false;
      this.modeCreation = false;
      this.modeModification = false;
      this.emptyForm();
    },
    /**
     * L'utilisateur a demandé la suppression (désactivation) d'un item
     * On va lui demander confirmation
     */
    deactivateItem(item) {
      // On transfère l'objet à mettre à jour dans le form
      this.itemToForm(item);
      this.form.actif = false;
      this.modalDeactivate = true;
    },
    /**
     * Annulation de la demande de suppression (désactivation)
     */
    abortDeactivate() {
      this.emptyForm();
      this.modalDeactivate = false;
      toasted.info('administration.parametreenum.results.cancel.success');
    },
    /**
     * Confirmation de la demande de suppression (désactivation)
     */
    confirmDeactivate() {
      this.modalDeactivate = false;
      this.$api(this.getApiWriteUrl() + '/' + this.form.id)
        .post(this.form)
        .then(
          () => {
            toasted.info(
              'administration.parametreenum.results.deactivate.success',
            );
            this.search();
          },
          () => {
            toasted.error(
              'administration.parametreenum.results.deactivate.error',
            );
          },
        );
      this.emptyForm();
    },
    /**
     * Copie d'un objet à éditer dans le form
     */
    itemToForm(item) {
      Object.assign(this.form, item);
      // On récupère le libellé des champs de type enum
      if (this._props.extraFields) {
        this._props.extraFields
          .filter(field => field.type === 'staticEnum')
          .forEach(extraField => {
            var libelle = item[extraField.name];
            this.$api(
              '/enum/' + extraField.enumNamespace + '/' + item[extraField.name],
            )
              .get()
              .then(
                data => {
                  if (
                    data.body &&
                    data.body.libelle &&
                    data.body.libelle !== ''
                  ) {
                    libelle = data.body.libelle;
                  }
                },
                () => {
                  toasted.error(
                    'administration.parametreenum.results.load.error',
                  );
                },
              );
            this.form[extraField.name + 'Object'] = Object.assign(
              {},
              {
                fieldName: extraField.name,
                fieldType: 'staticEnum',
                value: { id: item[extraField.name], libelle: libelle },
              },
            );
          });
      }
    },
    updateFormSpecialFields() {
      Object.keys(this.form).forEach(field => {
        if (
          this.form[field] &&
          this.form[field].fieldType &&
          this.form[field].fieldType === 'staticEnum'
        ) {
          this.form[this.form[field].fieldName] = this.form[field].value.id;
        }
      });
    },
    /**
     * Reset du form
     */
    emptyForm() {
      // On vide les champs
      Object.assign(this.form, this.blankForm);
      this.$v.$reset();
    },
    initFormDefaultValues() {
      // On initialise les champs avec valeur par défaut
      if (this._props.extraFields) {
        this._props.extraFields
          .filter(field => field.defaultValue != null)
          .forEach(extraField => {
            if (extraField.type === 'enum') {
              this.form[extraField.name] = Object.assign(
                extraField.defaultValue,
              );
            }
          });
      }
    },
    getModalEditionTitle() {
      var title = this.$i18n.t(this.title);
      if (this.modeCreation) {
        title +=
          ' ' +
          this.$i18n.t('administration.parametreenum.form.dialog.title.create');
      } else if (this.modeModification) {
        title +=
          ' ' +
          this.$i18n.t('administration.parametreenum.form.dialog.title.update');
      }
      return title;
    },
  },
  validations: {
    form: {},
  },
};
</script>

<style scoped></style>
